<template>
  <div class="version-display">
    Version: {{ version }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      version: 'Loading...'
    };
  },
  async mounted() {
    try {
      const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/version`);
      if (response.ok) {
        const data = await response.json();
        this.version = data.version;
      } else {
        this.version = 'Unknown';
      }
    } catch (error) {
      console.error('Error fetching version:', error);
      this.version = 'Error';
    }
  }
};
</script>

<style scoped>
.version-display {
  font-size: 0.8rem;
  color: #666;
}
</style>